import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select, { createFilter } from 'react-select';
import {
  Badge,
  Button,
  Collapse,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  addSelectedFilter,
  deleteSelectedFilter,
} from '../../actions/Files';

import FiltersResetButton from './FiltersResetButton';

class FiltersFileUsers extends Component {
  constructor(props) {
    super(props);

    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  getAvailableFilters() {
    const { availableFilters } = this.props;
    const options = [];
    availableFilters.forEach((filter) => {
      options.push({
        value: filter.key,
        label: filter.name,
      });
    });

    return options;
  }

  getSelectedFilters() {
    const {
      availableFilters,
      filters,
    } = this.props;
    const values = [];
    availableFilters.forEach((filter) => {
      if (window._.includes(filters, filter.key)) {
        values.push({
          value: filter.key,
          label: filter.name,
        });
      }
    });

    return values;
  }

  handleChangeFilter(values, action) {
    const {
      intl,
      filters,
      handleChangeFilters,
      addFilter,
      removeFilter,
    } = this.props;

    let newSelected = filters.slice(0);

    if (action.action === 'select-option') {
      const { option: value } = action;
      newSelected.push(value.value);
      addFilter({
        type: 'user_ids',
        key: value.value,
        label: value.label,
        title: intl.formatMessage({ defaultMessage: 'Owner' }),
      });
    }

    if (action.action === 'remove-value') {
      const { removedValue: value } = action;
      newSelected = newSelected.filter(s => (s !== value.value));
      removeFilter('user_ids', value.value);
    }

    if (action.action === 'clear') {
      this.getSelectedFilters().forEach((filter) => {
        newSelected = newSelected.filter(s => (s !== filter.value));
        removeFilter('user_ids', filter.value);
      });
    }

    handleChangeFilters({ user_ids: newSelected });
  }

  handleReset() {
    this.handleChangeFilter([], { action: 'clear' });
  }

  render() {
    const {
      intl,
      isOpen,
      handleToggleFilter,
    } = this.props;
    const selected = this.getSelectedFilters();
    const availableFilters = this.getAvailableFilters();

    if (availableFilters.length === 0) {
      return null;
    }

    return (
      <div className="files-filter file-users-filter">
        <div className="filter-header">
          <Button onClick={handleToggleFilter} className="filter-title">
            <i className={`fal fa-angle-${isOpen ? 'up' : 'down'}`} />
            <span>{intl.formatMessage({ defaultMessage: 'Owner' })}</span>
            {' '}
            {selected.length > 0 && (
              <Badge color="primary">
                {selected.length}
              </Badge>
            )}
          </Button>
          {selected.length > 0 && (
            <FiltersResetButton
              handleReset={this.handleReset}
            />
          )}
        </div>
        <Collapse
          isOpen={isOpen}
          className="filter-body"
        >
          <div className="filter-form file-users-filter-form">
            <Select
              id="filterFileUsers"
              inputId="filterFileUsersInput"
              classNamePrefix="filter-select"
              isClearable={false}
              isMulti
              options={availableFilters}
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              onChange={this.handleChangeFilter}
              value={selected}
            />
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  filters: props.customFilters ? props.customFilters.user_ids : state.Files.filters.user_ids,
  availableFilters: state.Files.availableFilters.user_ids,
});

const mapDispatchToProps = (dispatch, props) => ({
  addFilter: props.customAddFilter || ((filter) => {
    dispatch(addSelectedFilter(filter));
  }),
  removeFilter: props.customRemoveFilter || ((filterType, filterKey) => {
    dispatch(deleteSelectedFilter(filterType, filterKey));
  }),
});

FiltersFileUsers.propTypes = {
  intl: PropTypes.object.isRequired,
  filters: PropTypes.array.isRequired,
  availableFilters: PropTypes.array.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FiltersFileUsers));
